import React, { useState } from "react";
import UnsubscribeLogo from "../assets/img/illustrations/unsubscribe.png";
import SikkaLogo from "../assets/img/illustrations/new-sikka-logo.png";
import { Image, Button, Form } from "react-bootstrap";
import { Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import AuthService from "../services/authenticationService";
import SikkaInput from "../components/common/SikkaInput";
import { useForm } from "react-hook-form";
import Loader from "../components/common/Loader";

const Unsubscribe = () => {
  let history = useHistory();

  let search = window.location.search;
  let email = search.replace("?email=", "");
  const [isUnsubscribeButtonClicked, setIsUnsubscribeButtonClicked] = useState(
    false
  );

  const { register, handleSubmit, errors, setError, clearError } = useForm();

  const handleUnsubscribe = (values) => {
    if (values.description.length >= 5) {
      clearError();
      setIsUnsubscribeButtonClicked(true);
      const body = {
        email: email,
        description: values.description,
      };

      AuthService.unsubscribeCall(body).then(
        (response) => {
          toast.success(response.message);
          setIsUnsubscribeButtonClicked(false);
          setTimeout(() => {
            history.push(`${process.env.PUBLIC_URL}/authentication/login`);
          }, 3000);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setIsUnsubscribeButtonClicked(false);
          setTimeout(() => {
            history.push(`${process.env.PUBLIC_URL}/authentication/login`);
          }, 3000);
        }
      );
    } else {
      setError(
        "description",
        "custom",
        `Please add at least 5 characters.`
      );
    }
  };

  return (
    <div className="content">
      <div className="d-flex flex-column align-items-center pt-3 mb-6">
        <Image src={SikkaLogo} alt="SikkaLogo" height="30px" width="150px" />
        <div className="mb-2" />
        <Image
          src={UnsubscribeLogo}
          alt="UnsubscribeLogo"
          height="230px"
          width="280px"
        />
        <h4 className="text-900" style={{ fontWeight: "600" }}>
          Unsubscribe
        </h4>
        <h6>
          If you decide to unsubscribe, you will no longer receive emails.
        </h6>
        <Form
          onSubmit={handleSubmit(handleUnsubscribe)}
          style={{
            width: "500px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Form.Group>
            <SikkaInput
              name="description"
              id="description"
              placeholder="Description..."
              size="lg"
              className="fs--1"
              innerRef={register({
                required: "Description is required.",
              })}
              errors={errors}
            />
          </Form.Group>
          <Row>
            <Button
              disabled={isUnsubscribeButtonClicked}
              type="submit"
              variant="primary"
              size="sm"
              className="me-2 mb-1 mr-4 fs--1"
            >
              Unsubscribe
            </Button>
            <Button
              disabled={isUnsubscribeButtonClicked}
              variant="secondary"
              size="sm"
              className="me-2 mb-1 fs--1"
              onClick={() =>
                history.push(`${process.env.PUBLIC_URL}/authentication/login`)
              }
            >
              Cancel
            </Button>
          </Row>
        </Form>
      </div>
      <footer>
        <Row
          noGutters
          className="justify-content-between text-center fs--1 mt-4 mb-3 px-3"
        >
          <Col sm="auto">
            <p className="fs--1 mb-0 text-600">
              &copy; {new Date().getFullYear()} Copyright Sikka Software
              Corporation. All Rights Reserved | Leading AI infrastructure as a Service (AIaaS) for Retail Healthcare
            </p>
          </Col>
          <Col sm="auto">
            <p className="fs--1 mb-0 text-600">Sikka API Portal v4.0.0</p>
          </Col>
        </Row>
      </footer>
    </div>
  );
};

export default Unsubscribe;
